var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash"},[_c('img',{attrs:{"src":_vm.splashImg,"alt":""}}),_c('h2',[_vm._v(_vm._s(_vm.text))]),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$emit('nextSlide')}}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }